<div
  cdkDropList
  [cdkDropListData]="items"
  (cdkDropListDropped)="onDrop($event)"
  [cdkDropListEnterPredicate]="canDrop(allowedFieldCategories)"
  class="drop-area"
>
  <!--
  If we have an image, add a special CSS class which allows the parent component to align it to
  the right if it is placed in the last column
  -->
  <div
    [ngClass]="{
      'template-canvas-item-image': item && item.type === ReportTemplateFieldType.Image,
    }"
    cdkDrag
    [cdkDragData]="item"
    [cdkDragDisabled]="!item"
    (cdkDragDropped)="removeItem()"
  >
    @if (item) {
      <div>
        <!-- If we have an image, display it -->
        @if (item.type === ReportTemplateFieldType.Image) {
          <div class="image-container">
            <div>
              <img
                [src]="
                  item.value
                    | rotecImageV2: './assets/img/logo-main.png'
                    | safeAsync: 'image'
                    | async
                "
                alt="Logo"
                class="image-size"
              />
            </div>
            <div class="delete-image-icon">
              <rotec-icon-v2
                class="remove-item"
                svgIcon="close"
                (click)="removeItem()"
              ></rotec-icon-v2>
            </div>
          </div>
        } @else {
          <!-- Otherwise just render the common fields name -->
          <rotec-chip-v2
            [darkBlue]="true"
            icon="close"
            [iconPlacement]="'right'"
            (chipRemove)="removeItem()"
            class="remove-item"
          >
            {{ item.value ? item.value : (item.name | translate) }}
          </rotec-chip-v2>
        }
      </div>
    }
  </div>
</div>
